$shm_hitalama_components_embed $mol_view
	fqn \
	sub / <= instance null
